import './docketLeft.css';
import { TbDatabaseSearch } from "react-icons/tb";
import { WiCloudRefresh } from "react-icons/wi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { BiSolidBellRing } from "react-icons/bi";
import { VscChromeClose } from "react-icons/vsc";
import { useEffect, useState, useRef } from 'react';
import HocScreen from '../../../desktop/HocScreen';
import { FilterDocketOrders } from '../FilterDocketOrders/FilterDocketOrders';
import '../../../desktop/InvoicesList/InovicesList.css';

export default function DocketLeft({ data, setClose }) {
    const [searchInDocket, setSearchInDocket] = useState(false);
    const [filteredOrders, setFilteredOrders] = useState({});

    useEffect(() => {
        if (data && data.aufaFlights) {
            setFilteredOrders(data.aufaFlights || {});
        }
    }, [data]);

    const handleSearchClick = () => {
        setSearchInDocket(true);
    };

    const handleCloseSearch = () => {
        setSearchInDocket(false);
    };


    return (
        <div className="docket-left-div">
            <div>
                <p>נוצר ע"י</p>
                <p> {data['user']} </p>
            </div>

            <div>
                <p>נוצר בתאריך</p>
                <p> {data['date']} </p>
            </div>

            <div>
                <p>שם דוקט</p>
                <p> {data['name']} </p>
            </div>

            <div>
                <p>סטטוס</p>
                <p> {data['status']} </p>
            </div>

            <div>
                <p>הצעת מחיר</p>
                <p></p>
            </div>

            <div>
                <p> הערה </p>
                <p> 0 הערות </p>
            </div>

            <div>
                <p>הפעל תזכורת</p>
                <BiSolidBellRing className='docket-left-div-icon' />
            </div>

            <div>
                <div>
                    <button onClick={handleSearchClick}><p>חיפוש</p>
                        <TbDatabaseSearch className='docket-left-div-icon' />
                    </button>
                </div>
            </div>

            <div>
                <p>ריענון</p>
                <WiCloudRefresh className='docket-left-div-icon' />
            </div>

            <div>
                <p>מחק</p>
                <RiDeleteBin6Line className='docket-left-div-icon' />
            </div>

            <div>
                <p>סגירה</p>
                <VscChromeClose className='docket-left-div-icon' />
            </div>

            {
                searchInDocket &&
                <div className='docLeftSearch'>
                    <HocScreen
                        Comp={FilterDocketOrders}
                        head={'חיפוש בדוקט'}
                        setClose={handleCloseSearch}
                        value={searchInDocket}
                        setValue={handleCloseSearch}
                        CompProps={{
                            data: data || {},
                            setFilteredOrders: setFilteredOrders,
                            filteredOrders: filteredOrders
                        }}
                    />
                </div>
            }


        </div>
    )
}